import React from "react";
export const AddTimeSlotIcon = (props) => {
    return (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7.83333 11.3333H9.16667V8.66667H11.8333V7.33333H9.16667V4.66667H7.83333V7.33333H5.16667V8.66667H7.83333V11.3333ZM2.5 14V2H14.5V14H2.5ZM3.83333 12.6667H13.1667V3.33333H3.83333V12.6667Z", fill: "#4B4F5E" })));
};
//# sourceMappingURL=add-time-slot.js.map